const semanticClassNames = {
  root: 'checkbox-group',
  label: 'checkbox-group__label',
} as const;

export default semanticClassNames;
